/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

function initPager() {
	const forms = document.getElementsByClassName( 'wp-block-dataperk-form' );

	// eslint-disable-next-line no-undef
	const observer = new MutationObserver( function ( mutations ) {
		mutations.forEach( function ( mutation ) {
			if ( mutation.type === 'attributes' ) {
				const data = mutation.target.dataset;
				if ( data.currentPage > data.pages ) {
					data.currentPage = data.pages;
				} else if ( data.currentPage < 0 ) {
					data.currentPage = 0;
				}

				const pages = mutation.target.getElementsByClassName(
					'wp-block-dataperk-form-page'
				);
				for ( const page of pages ) {
					if ( page.dataset.pageNumber === data.currentPage ) {
						page.classList.add( 'current' );
					} else {
						page.classList.remove( 'current' );
					}
				}

				const indicators = mutation.target.getElementsByClassName(
					'wp-block-dataperk-form-pager__page-indicator'
				);
				for ( const indicator of indicators ) {
					indicator.classList.remove( 'before' );
					indicator.classList.remove( 'after' );

					if ( indicator.dataset.pageNumber === data.currentPage ) {
						indicator.classList.add( 'current' );
						indicator.classList.add( 'viewed' );
					} else {
						indicator.classList.remove( 'current' );
					}

					if ( indicator.dataset.pageNumber < data.currentPage ) {
						indicator.classList.add( 'before' );
					} else if ( indicator.dataset.pageNumber > data.currentPage ) {
						indicator.classList.add( 'after' );
					}
				}
			}
		} );
	} );

	for ( const form of forms ) {
		const pages = form.getElementsByClassName(
			'wp-block-dataperk-form-page'
		);
		form.dataset.currentPage = 1;
		form.dataset.pages = pages.length;
		observer.observe( form, {
			attributes: true,
		} );
		enumerate( pages );
		buildPager( form );
	}
}

function ready( fn ) {
	if ( document.readyState !== 'loading' ) {
		fn();
	} else {
		document.addEventListener( 'DOMContentLoaded', fn );
	}
}

function enumerate( pages ) {
	let count = 1;
	for ( const page of pages ) {
		page.dataset.pageNumber = count;
		if ( count === 1 ) {
			page.classList.add( 'current' );
			page.classList.add( 'first' );
		} else if ( count === pages.length ) {
			page.classList.add( 'last' );
		}
		count++;
	}
}

function buildPager( form ) {
	const pager = form.getElementsByClassName(
		'wp-block-dataperk-form-pager'
	);

	if ( pager.length ) {
		for( let i = 1; i <= form.dataset.pages; i++ ) {
			let page = document.createElement('button');
			page.classList.add('wp-block-dataperk-form-pager__page-indicator');

			if ( i === 1 ) {
				page.classList.add('current');
				page.classList.add('viewed');
			} else {
				page.classList.add('after');
			}

			page.dataset.pageNumber = i;
			page.addEventListener( 'click', gotoPage );
			pager[0].append(page);

			if ( i < form.dataset.pages ) {
				let spacer = document.createElement('div');
				spacer.classList.add('wp-block-dataperk-form-pager__spacer');
				pager[0].append(spacer);
			}
		}
	}
}

function gotoPage( event ) {
	event.preventDefault();
	const form = event.target.closest( '.wp-block-dataperk-form' );
	form.dataset.currentPage = event.target.dataset.pageNumber;
}

ready( initPager );
